/* "El fuego te encuentra" - scroll-scrubbed hero.
   Desktop: pinned stage, canvas draws a WebP frame sequence (frames/manifest.json), coarse-to-fine preload,
   smoothed playhead (lerp), copy cues timed to scroll. Fallback: scrub the mp4, then a static poster.
   Mobile: muted autoplay loop. prefers-reduced-motion: static end poster with headline. */
(function () {
  "use strict";
  var sec = document.querySelector("[data-flight]");
  if (!sec) return;
  var stage = sec.querySelector(".flight-stage"), cv = stage.querySelector("canvas"),
    poster = stage.querySelector(".flight-poster"), scrim = stage.querySelector(".flight-scrim"),
    end = stage.querySelector(".flight-end"), cues = [].slice.call(stage.querySelectorAll("[data-cue]"));
  var reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;
  var desk = matchMedia("(min-width: 900px)").matches;
  var saveData = navigator.connection && navigator.connection.saveData;
  var D = sec.dataset;

  function usePosterEnd() {
    if (!D.posterEnd || !poster) return;
    var pic = poster.parentNode;
    if (pic && pic.tagName === "PICTURE") [].slice.call(pic.querySelectorAll("source")).forEach(function (s) { s.srcset = D.posterEnd; });
    poster.removeAttribute("srcset"); poster.src = D.posterEnd;
  }

  /* ---------- static / mobile ---------- */
  if (reduce || saveData || !desk || (!D.frames && !D.video)) {
    if (!reduce && !saveData && !desk && D.mvideo) {
      var v = document.createElement("video");
      v.muted = true; v.loop = true; v.autoplay = true; v.playsInline = true; v.setAttribute("playsinline", "");
      v.setAttribute("aria-hidden", "true"); v.preload = "auto"; v.poster = D.posterEnd || "";
      v.style.opacity = "0"; v.style.transition = "opacity .5s";
      v.src = D.mvideo;
      stage.insertBefore(v, cv);
      v.addEventListener("playing", function () { v.style.opacity = "1"; });
      var p = v.play(); if (p && p.catch) p.catch(function () {});
    } else if (desk) { usePosterEnd(); }
    return;
  }

  /* ---------- scrub mode ---------- */
  sec.classList.add("scrub");
  var hdr = parseFloat(getComputedStyle(document.documentElement).getPropertyValue("--hdr")) || 64;
  var cur = 0, target = 0, running = false, drawn = -1;
  var frames = [], n = 0, ctx = null, videoEl = null, mode = "";
  var cueWin = cues.map(function (c) { return c.getAttribute("data-cue").split(",").map(Number); });
  var endAt = parseFloat(end.getAttribute("data-end")) || 0.86;

  function clamp(x) { return x < 0 ? 0 : x > 1 ? 1 : x; }
  function progress() {
    var r = sec.getBoundingClientRect(), dist = sec.offsetHeight - (innerHeight - hdr);
    return dist > 0 ? clamp((hdr - r.top) / dist) : 0;
  }
  // scroll progress -> video progress; the last (1 - HOLD) of the scroll holds the final frame
  var HOLD = parseFloat(D.hold) || 1;
  function vp(p) { return Math.min(1, p / HOLD); }
  function win(p, a, b) { var f = 0.02; return Math.min(clamp((p - a) / f), clamp((b - p) / f)); }

  function size() {
    if (!cv) return;
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    cv.width = Math.round(stage.clientWidth * dpr); cv.height = Math.round(stage.clientHeight * dpr);
    drawn = -1;
  }
  function cover(img) {
    var cw = cv.width, ch = cv.height, iw = img.naturalWidth || img.videoWidth, ih = img.naturalHeight || img.videoHeight;
    if (!iw) return;
    var s = Math.max(cw / iw, ch / ih), w = iw * s, h = ih * s;
    ctx.drawImage(img, (cw - w) / 2, (ch - h) / 2, w, h);
  }
  function nearest(i) {
    for (var d = 0; d < n; d++) {
      if (i - d >= 0 && frames[i - d] && frames[i - d].ok) return i - d;
      if (i + d < n && frames[i + d] && frames[i + d].ok) return i + d;
    }
    return -1;
  }
  function paint() {
    if (mode === "frames") {
      var k = nearest(Math.round(vp(cur) * (n - 1)));
      if (k >= 0 && k !== drawn) { cover(frames[k].img); drawn = k; if (!cv.classList.contains("ready")) cv.classList.add("ready"); }
    } else if (mode === "video" && videoEl && videoEl.duration) {
      var t = vp(cur) * (videoEl.duration - 0.05);
      if (Math.abs(videoEl.currentTime - t) > 0.02 && !videoEl.seeking) videoEl.currentTime = t;
    }
    cues.forEach(function (c, i) {
      var o = win(vp(cur), cueWin[i][0], cueWin[i][1]);
      c.style.opacity = o; c.style.transform = "translateY(" + ((1 - o) * 24).toFixed(1) + "px)";
    });
    var e = clamp((vp(cur) - endAt) / 0.03);
    end.style.opacity = e; end.style.transform = "translateY(" + ((1 - e) * 24).toFixed(1) + "px)";
    end.style.pointerEvents = e > 0.5 ? "auto" : "none";
    scrim.style.opacity = (0.35 + 0.65 * e).toFixed(2);
  }
  function tick() {
    target = progress();
    cur += (target - cur) * 0.16;
    if (Math.abs(target - cur) < 0.0004) cur = target;
    paint();
    if (running) requestAnimationFrame(tick);
  }
  new IntersectionObserver(function (es) {
    var on = es[0].isIntersecting;
    if (on && !running) { running = true; requestAnimationFrame(tick); }
    if (!on) running = false;
  }).observe(sec);
  addEventListener("resize", function () { size(); paint(); });
  // keyboard / assistive tech: the end copy must be reachable even mid-scrub
  end.addEventListener("focusin", function () { end.style.opacity = 1; end.style.pointerEvents = "auto"; });

  /* frames */
  function loadFrames(m, base) {
    n = m.count || m.frameCount || m.total || (m.frames && m.frames.length) || 0;
    if (!n) throw new Error("empty manifest");
    var pad = m.pad || 4, prefix = m.prefix || "f", ext = m.ext || "webp", start = m.start != null ? m.start : 1;
    var name = function (i) {
      if (m.frames && m.frames[i]) return typeof m.frames[i] === "string" ? m.frames[i] : m.frames[i].src || m.frames[i].file;
      if (m.pattern) return m.pattern.replace(/%0(\d)d/, function (_, w) { return String(i + start).padStart(+w, "0"); });
      return prefix + String(i + start).padStart(pad, "0") + "." + ext;
    };
    if (m.cues) {
      // optional timing override from the generator: {"yacht":[a,b],"villa":[a,b],"end":x}
      if (m.cues.yacht) cueWin[0] = m.cues.yacht;
      if (m.cues.villa) cueWin[1] = m.cues.villa;
      if (m.cues.end) endAt = m.cues.end;
    }
    ctx = cv.getContext("2d"); size(); mode = "frames";
    frames = new Array(n);
    var order = [], seen = {};
    [32, 16, 8, 4, 2, 1].forEach(function (st) { for (var i = 0; i < n; i += st) if (!seen[i]) { seen[i] = 1; order.push(i); } });
    if (!seen[n - 1]) order.push(n - 1);
    var q = 0, active = 0, MAX = 6;
    function next() {
      while (active < MAX && q < order.length) {
        (function (i) {
          active++;
          var im = new Image(); im.decoding = "async";
          frames[i] = { img: im, ok: false };
          im.onload = function () { frames[i].ok = true; active--; if (i === 0 || drawn < 0) paint(); next(); };
          im.onerror = function () { active--; next(); };
          im.src = base + name(i) + (window.__qv || "");
        })(order[q++]);
      }
    }
    next();
  }
  function loadVideo() {
    mode = "video";
    videoEl = document.createElement("video");
    videoEl.muted = true; videoEl.playsInline = true; videoEl.preload = "auto"; videoEl.setAttribute("aria-hidden", "true");
    videoEl.style.opacity = "0"; videoEl.style.transition = "opacity .4s";
    videoEl.src = D.video;
    stage.insertBefore(videoEl, cv);
    videoEl.addEventListener("seeked", function () { videoEl.style.opacity = "1"; });
    videoEl.addEventListener("loadeddata", function () { paint(); });
  }
  function start() {
    if (D.frames) {
      var base = D.frames.split("?")[0].replace(/[^/]*$/, ""), qv = D.frames.indexOf("?") > -1 ? D.frames.slice(D.frames.indexOf("?")) : "";
      fetch(D.frames).then(function (r) { if (!r.ok) throw 0; return r.json(); })
        .then(function (m) { window.__qv = qv; loadFrames(m, m.base ? m.base : base); })
        .catch(function () { if (D.video) loadVideo(); else { sec.classList.remove("scrub"); usePosterEnd(); } });
    } else loadVideo();
  }
  paint();
  // let the poster (LCP) and fonts win the network first
  if (document.readyState === "complete") setTimeout(start, 150);
  else addEventListener("load", function () { setTimeout(start, 150); });
})();
